import { render, staticRenderFns } from "./ShopgenieFooter.vue?vue&type=template&id=5b9bbe17"
import script from "./ShopgenieFooter.vue?vue&type=script&lang=js"
export * from "./ShopgenieFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports